// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3pWZl","selected":"Chip_selected__3MKeq"};